import { render } from "./DavidShannon.vue?vue&type=template&id=4a8da3c4&ts=true"
import script from "./DavidShannon.vue?vue&type=script&lang=ts"
export * from "./DavidShannon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__